
import React, { useEffect, useState } from 'react';

// Mui
import { SelectTheme } from './SelectTheme';
import Grid from '@mui/material/Grid';

// Redux store
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";

// helpers
import { setLogged } from '../redux/slices/logged';

// requets
import { logoutKeycloak } from '../request/keycloak/logoutKeycloak';
import { MenuBar } from './MenuBar';
import { SideBar } from './SideBar';
import { IconMap } from './IconMap';
import { ListItemIcon } from '@mui/material';
import { diag_WH } from '../helpers/diag_WH';
import { breakPoints } from '../helpers/breakPoint';
import { dateNavBar } from '../helpers/dateNavBar';


export const NavBar = ({ setTheme, theme, menus }) => {

    const dispatch = useDispatch();
    const loggedStore = useSelector(state => state.loggedStore.value)
    const iconLabel = useSelector(state => state.icomMapStore.value)

    const loggedMenus = menus.logged.filter(label => label !== 'operacion')

    const styleBox = {
        fontFamily: 'Roboto',
        bgcolor: 'background.default',
        color: 'text.primary',
        paddingTop: '1vh',
        paddingLeft: '1vh',
        zIndex: '100'
    }

    const styleContent = {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'space-between',
        marginLeft: diag_WH(35)
    }

    const handleclick = () => {

        logoutKeycloak(loggedStore.token)

        dispatch(setLogged({
            state: false,
            token: null
        }))

        sessionStorage.clear()
        window.location.href = '/home';
    }

    return (
        <Grid
            container
            direction="row"
            spacing={2}
            sx={{
                position: 'fixed',
                display: 'flex',
                width: '100%',
                top: '0',
                justifyContent: "flex-start",
                alignItems: "center",
                gap: '0.75vh',
                ...styleBox
            }}
            columns={15}
        >
            <Grid
                size={{ mobile: 1, tablet: 1, laptop: 1 }}
                container
                direction="row"
                spacing={1}
                sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                }}
            >
                {
                    window.innerWidth < 1024
                        ? <MenuBar
                            handle={handleclick}
                            tema={{ setTheme, theme }}
                            menus={{ noLogged: menus.noLogged, logged: loggedMenus }}
                        />
                        : <SideBar
                            menuItems={loggedStore.state ? loggedMenus : menus.noLogged}
                            handleOut={handleclick}
                        />
                }
            </Grid>

            <Grid size={13} sx={{ textAlign: 'start' }}>
                <div style={styleContent}>

                    <ListItemIcon sx={{ alignItems: 'center', paddingLeft: breakPoints(['0.5vw', '0.5vw', '3vw']) }}>
                        {IconMap[iconLabel]}
                    </ListItemIcon>

                    <div style={{ alignContent: 'center' }}>
                        <strong >
                            {dateNavBar(loggedStore?.credentials?.user)}
                        </strong>
                    </div>
                    {
                        window.innerWidth > 1024
                        &&
                        <SelectTheme setValue={setTheme} mode={theme} />
                    }
                </div>
            </Grid>

            <Grid size={15}>
                <hr style={{ margin: 0 }} />
            </Grid>
        </Grid>
    )
}